webpackJsonp([278932160241570],{

/***/ 1630:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/pamela-williams/","posts":[{"fields":{"slug":"/news/perks-a-year-of-points-and-prizes/","author":{"id":"/opt/build/repo/src/pages/people/pamela-williams.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"PERKS: A year of points and prizes","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1200x1200-perks-1-year-article-thumbnail-v1-f52d375aaaa002de21df3c646cad290a.jpg"}}},"original":"/img/1200x1200-perks-1-year-article-thumbnail-v1.jpg"},"category":"News"}}]},"frontmatter":{"title":"Pamela Williams"}}}]}},"pathContext":{"author":"/people/pamela-williams/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-pamela-williams-ac464a8e35801560264e.js